import React from 'react';
import styled from 'styled-components';
import {getNavItems, isNavLinkSelected} from '../../Utils/NavUtil';
import {Link} from 'gatsby';
import useArea from '../../Hooks/useArea';

export default function Breadcrumb(props) {
  const {first = '首頁', second, third} = props;
  const {isDoctor} = useArea();
  const navItems = getNavItems({...props, isDoctor});

  const {navItem, subItem} = React.useMemo(() => {
    let navItem = navItems.find((x) => isNavLinkSelected(x));
    let subItem = null;
    if (!navItem) {
      for (let item of navItems) {
        if (Array.isArray(item.entries)) {
          subItem = item.entries.find((x) => isNavLinkSelected(x));
          if (subItem) {
            return {navItem: item, subItem};
          }
        }
      }
    }
    return {navItem};
  }, [navItems]);

  return (
    <Wrapper>
      <div>
        <Link style={{color: '#999'}} to={'/'}>
          {first}
        </Link>
      </div>
      <div>/</div>
      <div>{second || navItem?.name}</div>
      {subItem?.name || third ? <div>/</div> : null}
      <div>{third || subItem?.name}</div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #999;

  & > *:not(:first-child) {
    margin-left: 5px;
  }
`;
